(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CARS = {
    'BMW': { '3-serie': ['F30 (2012–2019)', 'G20 (2019–)'], '5-serie': ['F10 (2010–2017)', 'G30 (2017–2023)'], 'X5': ['F15 (2013–2018)', 'G05 (2018–)'] },
    'Audi': { 'A3': ['8V (2012–2020)', '8Y (2020–)'], 'A4': ['B9 (2015–2024)'], 'Q5': ['FY (2017–)'] },
    'Mercedes-Benz': { 'C-klass': ['W205 (2014–2021)', 'W206 (2021–)'], 'E-klass': ['W213 (2016–2023)'], 'GLC': ['X253 (2015–2022)'] },
    'Volvo': { 'XC60': ['Andra generationen (2017–)'], 'V60': ['Andra generationen (2018–)'], 'XC90': ['Andra generationen (2015–)'] }
  };
  function once(el){ if(el.dataset.on) return false; el.dataset.on = '1'; return true; }
  function init(root){
    root.querySelectorAll('[data-skd-size]').forEach(function(s){
      if(!once(s)) return;
      var unit = 'cm', stop = false, btns = s.querySelectorAll('[data-unit]'), rows = s.querySelectorAll('tbody tr'), i = 0;
      function render(){ s.querySelectorAll('[data-cm]').forEach(function(td){ var v = parseFloat(td.getAttribute('data-cm')); td.textContent = unit === 'cm' ? v + ' cm' : (v / 2.54).toFixed(1) + ' tum'; }); }
      btns.forEach(function(b){ b.addEventListener('click', function(){ unit = b.getAttribute('data-unit'); btns.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); render(); }); });
      s.addEventListener('pointerdown', function(){ stop = true; });
      render();
      if(reduce) return;
      setInterval(function(){ if(stop) return; rows.forEach(function(r){ r.classList.remove('is-hl'); }); rows[i % rows.length].classList.add('is-hl'); i++; }, 1400);
    });
    root.querySelectorAll('[data-skd-ship]').forEach(function(s){
      if(!once(s)) return;
      var goal = parseInt(s.getAttribute('data-goal'), 10), price = parseInt(s.getAttribute('data-price'), 10), total = 0, stop = false;
      var list = s.querySelector('.skd-ship__items'), fill = s.querySelector('.skd-ship__fill'), msg = s.querySelector('.skd-ship__msg'), sum = s.querySelector('[data-sum]');
      function render(){
        var left = goal - total;
        fill.style.width = Math.min(100, total / goal * 100) + '%';
        s.classList.toggle('is-done', left <= 0);
        msg.textContent = left > 0 ? 'Handla för ' + left + ' kr till så får du fri frakt' : 'Grattis – du har fri frakt!';
        sum.textContent = total + ' kr';
      }
      function add(){
        total += price;
        var it = document.createElement('div'); it.className = 'skd-ship__item';
        it.innerHTML = "<span class='skd-ship__thumb'></span><span style='flex:1'>Exempelprodukt</span><b>" + price + " kr</b>";
        list.appendChild(it); if(list.children.length > 3) list.removeChild(list.firstChild);
        render();
      }
      function reset(){ total = 0; list.innerHTML = ''; render(); }
      s.querySelector('[data-add]').addEventListener('click', function(e){ if(!e.isTrusted) return; stop = true; add(); });
      s.querySelector('[data-reset]').addEventListener('click', function(e){ if(!e.isTrusted) return; stop = true; reset(); });
      render();
      if(reduce) return;
      function loop(){
        if(stop) return;
        if(total >= goal){ setTimeout(function(){ if(stop) return; reset(); setTimeout(loop, 900); }, 2600); return; }
        add(); setTimeout(loop, 1500);
      }
      setTimeout(loop, 900);
    });
    root.querySelectorAll('[data-skd-news]').forEach(function(n){
      if(!once(n)) return;
      var f = n.querySelector('form'), inp = n.querySelector('input'), stop = false, demo = 'anna@exempel.se';
      f.addEventListener('submit', function(e){ e.preventDefault(); stop = true; n.classList.add('is-ok'); });
      n.querySelector('[data-again]').addEventListener('click', function(){ stop = true; n.classList.remove('is-ok'); inp.value = ''; inp.focus({ preventScroll: true }); });
      inp.addEventListener('focus', function(){ stop = true; });
      if(reduce) return;
      function play(){
        if(stop) return;
        n.classList.remove('is-ok'); inp.value = '';
        var k = 0;
        (function type(){
          if(stop) return;
          if(k <= demo.length){ inp.value = demo.slice(0, k++); setTimeout(type, 70); }
          else setTimeout(function(){ if(stop) return; n.classList.add('is-ok'); setTimeout(play, 3200); }, 600);
        })();
      }
      setTimeout(play, 1000);
    });
    root.querySelectorAll('[data-skd-cd]').forEach(function(c){
      if(!once(c)) return;
      function target(){ var n = new Date(), t = new Date(n); t.setDate(n.getDate() + (7 - n.getDay()) % 7); t.setHours(23, 59, 59, 0); if(t <= n) t.setDate(t.getDate() + 7); return t; }
      var end = target(), els = { d: c.querySelector('[data-d]'), h: c.querySelector('[data-h]'), m: c.querySelector('[data-m]'), s: c.querySelector('[data-s]') };
      function label(){ c.querySelector('[data-end]').textContent = end.toLocaleDateString('sv-SE', { weekday: 'long', day: 'numeric', month: 'long' }) + ' kl. 23:59'; }
      function pad(x){ return (x < 10 ? '0' : '') + x; }
      function set(el, v){ if(el.textContent === v) return; el.textContent = v; if(!reduce){ el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick'); } }
      function tick(){
        var ms = end - new Date(); if(ms <= 0){ end = target(); label(); ms = end - new Date(); }
        var s = Math.floor(ms / 1000);
        set(els.d, pad(Math.floor(s / 86400))); set(els.h, pad(Math.floor(s % 86400 / 3600))); set(els.m, pad(Math.floor(s % 3600 / 60))); set(els.s, pad(s % 60));
      }
      label(); tick(); setInterval(tick, 1000);
    });
    root.querySelectorAll('[data-skd-car]').forEach(function(c){
      if(!once(c)) return;
      var mk = c.querySelector('[data-l=make]'), md = c.querySelector('[data-l=model]'), yr = c.querySelector('[data-l=year]'), go = c.querySelector('[data-go]'), res = c.querySelector('.skd-car__res'), stop = false;
      function fill(sel, items, ph){ sel.innerHTML = ''; var o = document.createElement('option'); o.value = ''; o.textContent = ph; sel.appendChild(o); items.forEach(function(v){ var x = document.createElement('option'); x.value = v; x.textContent = v; sel.appendChild(x); }); sel.disabled = !items.length; sel.classList.remove('is-set'); }
      function update(){ mk.classList.toggle('is-set', !!mk.value); md.classList.toggle('is-set', !!md.value); yr.classList.toggle('is-set', !!yr.value); go.disabled = !yr.value; }
      function setMake(){ fill(md, mk.value ? Object.keys(CARS[mk.value]) : [], 'Välj modell'); fill(yr, [], 'Välj generation'); update(); }
      function setModel(){ fill(yr, md.value ? CARS[mk.value][md.value] : [], 'Välj generation'); update(); }
      function show(){ res.innerHTML = 'Visar delar som passar <b>' + mk.value + ' ' + md.value + ' ' + yr.value + '</b>'; }
      fill(mk, Object.keys(CARS), 'Välj märke'); fill(md, [], 'Välj modell'); fill(yr, [], 'Välj generation');
      mk.addEventListener('change', setMake);
      md.addEventListener('change', setModel);
      yr.addEventListener('change', update);
      go.addEventListener('click', show);
      [mk, md, yr, go].forEach(function(el){ el.addEventListener('pointerdown', function(){ stop = true; }); el.addEventListener('keydown', function(){ stop = true; }); });
      update();
      if(reduce) return;
      var makes = Object.keys(CARS), n = 0;
      function play(){
        if(stop) return;
        var m = makes[n % makes.length], mods = Object.keys(CARS[m]), mo = mods[n % mods.length], y = CARS[m][mo][CARS[m][mo].length - 1]; n++;
        res.textContent = 'Välj din bil så visar vi bara delar som passar.';
        mk.value = ''; setMake();
        setTimeout(function(){ if(stop) return; mk.value = m; setMake();
          setTimeout(function(){ if(stop) return; md.value = mo; setModel();
            setTimeout(function(){ if(stop) return; yr.value = y; update();
              setTimeout(function(){ if(stop) return; show(); setTimeout(play, 2800); }, 700);
            }, 800);
          }, 800);
        }, 600);
      }
      setTimeout(play, 1000);
    });
  }
  function boot(){ init(document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();